<template>
  <div class="tag" ref="tag" >
    <h2 v-html="currentTagObject.text"></h2>
    
    <div :class="['overview', 'length-'+projectsByTag.length, 'length-dec-'+Math.floor(projectsByTag.length/10)]">
      <div class="inner main">
        <div class="project" v-for="project in projectsByTag">
          <router-link :key="project.id" class="block" :tags="tags" :to="{name:'project',params:{tag:currentTag,project:project.slug}}">
            <div class="title" v-html="project.title"></div>
            <div class="container" :style="padding(project)">
              <img :src="project.image">  
            </div>
          </router-link>
        </div>
      </div>
      <!-- <h2>
        More Projects
      </h2>
      <div class="inner other">
        <div class="project" v-for="project in projectsByTagOther">
          <router-link :key="project.id" class="block" :tags="tags" :to="{name:'project',params:{tag:'all',project:project.slug}}">
            <div class="container" :style="padding(project)">
              <img :src="project.image">  
            </div>
            <div class="title" v-html="project.title"></div>
          </router-link>
        </div>
      </div> -->
    </div>
    <router-view v-if="currentProject" :tags="tagsCurrentProject" :project="currentProject"></router-view>
  </div>
</template>
<script>
  import Project from './Project'
  export default {
    data() {
      return{
        showInfo: false
      }
    },
    components: {
      Project
    },
    props: {
      projects: Array,
      tags: Array
    },
    methods: {

      toggleInfo() {
        this.showInfo = !this.showInfo;
      },
      firstProject: function(tag) {
        return this.projects.filter(project => project.tags.includes(tag))[0].slug;
      },
      padding (project) {
        let p = project.height / project.width * 100;
        return 'padding-bottom:' + p + '%';
      },
    },
    computed: {
      currentProject () {
        return this.projectsByTag.find(project => project.slug == this.$route.params.project)
      },
      currentProjectIndex () {
        return this.projectsByTag.findIndex(project => project.slug == this.$route.params.project)
      },
      nextProject () {
        const i = this.currentProjectIndex;
        if(i==this.projectsByTag.length-1) {
          return this.projectsByTag[0];
        } else {
          return this.projectsByTag[i+1];
        }
      },
      currentTag () {  
        return this.$route.params.tag
      },
      currentTagObject () {
        return this.tags.find(tag => tag.name==this.currentTag);
      },
      projectsByTag () {
        const projectIdsByTag = this.currentTagObject.projects;
        return this.projects.filter(project => {
          const exists = (projectIdsByTag.indexOf(project.id) !== -1);
          return exists;
        });
      },
      projectsByTagOther () {
        const projectIdsByTag = this.currentTagObject.projects;
        return this.projects.filter(project => {
          const exists = (projectIdsByTag.indexOf(project.id) == -1);
          return exists;
        });
      },
      tagsCurrentProject () {
        let p = this.currentProject;
        const currentTags = this.tags.filter(tag => {
          return tag.projects.indexOf(p.id) != -1 && !tag.hidefromproject;
        })
        return currentTags;
      }
    }
  }
</script>
<style lang="scss">
@import 'global';
.tag {
  .description {
    margin-bottom: 2rem;
    max-width: 50rem;
  }
  h2 {
    margin:1rem 0;
  }

  @media #{$medium-up} {
    .overview.length-dec-0 .inner {
      grid-template-columns: repeat(2, 1fr);
    }
    .overview.length-dec-1 .inner {
      grid-template-columns: repeat(3, 1fr);
    }
    .overview.length-dec-4 .inner,
    .overview.length-dec-3 .inner,
    .overview.length-dec-2 .inner {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  @media #{$small-down} {
    
    .overview.length-dec-2 .inner {
      grid-template-columns: repeat(2, 1fr);
    }
  }


  .overview {
      .inner {

      }

    // text-align: center;
    
    // width: 100%;
    // width: 100vw;
    
    .inner {
      
      // display: flex;
      // flex-flow: row wrap;
      // justify-content: space-between;
      perspective:700px;  
      display:grid;
      grid-gap:1.5rem;
      
      &.main {
        .project {
          transform: rotateY(25deg);
          transform-origin:0% 0%;  
          mix-blend-mode: lighten;
        }
        // @media #{$medium-up} {
          // grid-template-columns: repeat(2, 1fr);
          
          // .project {
            
            // &:nth-child(odd) {
            //   transform: rotateY(30deg);
            //   transform-origin:0% 0% ;  
            // }
            // &:nth-child(even) {
            //   transform: rotateY(-30deg);
            //   transform-origin:100% 0% ;  
            // }
          // }
        // }
      }
      &.other {
          max-width:900px;
          margin-right: auto;
          margin-left: auto;
          .project {
            transform: rotateX(20deg);
            transform-origin:50% 100%;  

          }

          grid-template-columns: repeat(2, 1fr);
          @media (min-width:$small) {
            grid-template-columns: repeat(4, 1fr);
          }
          @media (min-width:$medium) {
            grid-template-columns: repeat(6, 1fr);
          }
          font-size: 1rem;
          img {
            // object-fit: cover;
          }
      }

      .project {
        // border:1px solid red;
        // max-width: 100%;
        // width:100%;
        
        // max-height: 80vh;
        transition: transform 0.2s ease;

        //  &:hover {
        //     img {
        //       box-shadow: 0 0 2.3rem rgba(255,255,255,0.8);  
        //     }

            
        //   }
        
        flex: 0 1 auto;
        // margin-right:4rem;
        margin-bottom: 2vw;
        .container {
          position: relative;
          img {
            position: absolute;
            width: 100%;
            top:0;
            left:0;
          }
        
         
          text-decoration: none;
          display: block;
          img {
            max-width: 100%;
            transition: box-shadow 0.2s ease;
            box-shadow: 0 0 2.2rem rgba(255,255,255,0.5);
            // max-width: 100%;
            vertical-align: bottom;
          }  
          .title {
            padding:10px 0;
            text-shadow:0px 0px 10px rgba(255,255,255,0.5);
          }
        }
      }
    }

  }
}

</style>
